import React, { memo, useState, useEffect, useCallback } from 'react'
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { get } from '@/components/SlickGrid/example/lazy/request'


// Create a client
const queryClient = new QueryClient()



const getDate = (params) => get<any>('/api/getCurrentDateTime', params, {})

function Todos() {
  const [dateStr, setDateStr] = useState('');
  const [count, setCount] = useState(0)
  // Access the client
  const queryClient = useQueryClient()

  // Queries
  const { data, isLoading } = useQuery({ queryKey: ['todos'], queryFn: getDate })
  // Mutations
  const mutation = useMutation({
    mutationFn: getDate,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: ['todos'] })
    },
  })

  const handleClick = () => {
    const params = {
      id: Date.now(),
      title: 'Do Laundry',
    }
    mutation.mutate(params)
  }

  const handleCount = () => {
    setCount(count + 1)
  }

  console.log("render", { data, isLoading })

  return (
    <div>
      {/* <ul>{query.data?.map((todo) => <li key={todo.id}>{todo.title}</li>)}</ul> */}
      <button onClick={handleClick}>重新发送</button>
      <button onClick={handleCount}>count</button>
      <div>{data?.datetime}</div>
      <div>{count}</div>
      {/* <button
        onClick={() => {
          mutation.mutate({
            id: Date.now(),
            title: 'Do Laundry',
          })
        }}
      >
        Add Todo
      </button> */}
    </div>
  )
}


export default function App() {
  return (
    // Provide the client to your App
    <QueryClientProvider client={queryClient}>
      <Todos />
    </QueryClientProvider>
  )
}